import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import * as moment from "moment";

declare var jQuery: any;
declare var $: any; 

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})
export class PlayerComponent implements OnInit {

	playerManList: any = "";
	playerWomanList: any = "";
	playerAcademyList: any = "";
	playerCoachingList: any = "";
	playerrequest: any = {};

  constructor(private allpagesService: AllPageService,) { }

  ngOnInit() {
	this.loadplayerMan();
	this.loadplayerAcademy();
	this.loadplayerWomen();
	this.loadplayerCoaching();
	
    jQuery(".courses-name").click(function(){
	    if(jQuery(this).hasClass('active')){
	        // do nothing
	    }else{
	        var tabid = jQuery(this).attr('id');
	        jQuery(".courses-name").removeClass('active');
	        jQuery(this).addClass('active');
	        jQuery(".course-main-content").removeClass('active');
	        jQuery("#"+tabid+"-content").addClass("active");
	    }
	    return false;
	});
	
  }

  loadplayerMan() {
	this.playerrequest = {
		team_type : 'Men'
	};
	let request = Object.assign({}, this.playerrequest);
	this.allpagesService.getPlayerlist(request).then((data: any) => {
		this.playerManList = data;
		console.log(this.playerManList);
		setTimeout(() => {
			jQuery(".coaching").slice(0, 4).show();
			 jQuery("#loadMore").on("click", function(e){
			  e.preventDefault();
			  jQuery(".coaching:hidden").slice(0, 4).slideDown();
			  if(jQuery(".coaching:hidden").length == 0) {
			  jQuery("#loadMore").text("No Content").addClass("noContent");
			}
		});
		jQuery(".first-players").slice(0, 4).show();
		console.log("call");
			 jQuery("#loadMoreone").on("click", function(e){
			  e.preventDefault();
			  jQuery(".first-players:hidden").slice(0, 4).slideDown();
			  if(jQuery(".first-players:hidden").length == 0) {
			  jQuery("#loadMoreone").text("No Content").addClass("noContent");
			}
		});
		jQuery(".academy-players").slice(0, 4).show();
			   jQuery("#loadMorethree").on("click", function(e){
			   e.preventDefault();
			   jQuery(".academy-players:hidden").slice(0, 4).slideDown();
			   if(jQuery(".academy-players:hidden").length == 0) {
			   jQuery("#loadMorethree").text("No Content").addClass("noContent");
			}
		});
		jQuery(".women-players").slice(0, 4).show();
			 jQuery("#loadMoretwo").on("click", function(e){
			 e.preventDefault();
			 jQuery(".women-players:hidden").slice(0, 4).slideDown();
			 if(jQuery(".women-players:hidden").length == 0) {
			  jQuery("#loadMoretwo").text("No Content").addClass("noContent");
		   }
		});
		}, 1000);
	});
}

loadplayerWomen() {
	this.playerrequest = {
		team_type : 'Women'
	};
	let request = Object.assign({}, this.playerrequest);
	this.allpagesService.getPlayerlist(request).then((data: any) => {
		this.playerWomanList = data;
		console.log(this.playerWomanList);
	});
}

loadplayerAcademy() {
	this.playerrequest = {
		team_type : 'Academy'
	};
	let request = Object.assign({}, this.playerrequest);
	this.allpagesService.getPlayerlist(request).then((data: any) => {
		this.playerAcademyList = data;
		console.log(this.playerAcademyList);
	});
}

loadplayerCoaching() {
	this.playerrequest = {
		team_type : 'Coaching_Staff'
	};
	let request = Object.assign({}, this.playerrequest);
	this.allpagesService.getPlayerlist(request).then((data: any) => {
		this.playerCoachingList = data;
		console.log(this.playerCoachingList);
	});
}

}
